/**
 * Login desligado no frontend público (AB#12105).
 *
 * Regra do MPF: ninguém faz login pelo endereço público (www). Usuários
 * internos entram pelo endereço interno; editores externos, pelo hub
 * (novoportal, Access Manager). O bloqueio de verdade está na borda (a
 * chamada de login da API responde 403 no www); aqui só se tira o convite
 * ao login da interface, para o visitante não cair num formulário que
 * nunca entra.
 *
 * A variável é lida em tempo de execução (não no build), porque a MESMA
 * imagem serve o público, o hub e o frontend interno: só o Deployment do
 * público a define. No servidor ela vem de `process.env`; no navegador, de
 * `window.env`, que o `Html.jsx` monta a partir das variáveis `RAZZLE_*`.
 */
import { runtimeConfig } from '@plone/volto/runtime_config';

export const VARIAVEL_LOGIN_DESLIGADO = 'RAZZLE_LOGIN_DESLIGADO';

const VALORES_LIGADOS = ['true', '1', 'sim', 'yes', 'on'];

export const loginDesligado = (
  env: Record<string, unknown> | undefined = runtimeConfig as Record<
    string,
    unknown
  >,
): boolean => {
  const valor = env?.[VARIAVEL_LOGIN_DESLIGADO];
  if (valor === undefined || valor === null) return false;
  return VALORES_LIGADOS.includes(String(valor).trim().toLowerCase());
};
